import {useSigma} from "@react-sigma/core";
import React, {useEffect} from "react";
import {useTheCellMapContext} from "../../contexts/TheCellMapContext";

import {drawHover, drawLabel} from "../../utils/draw";

const GraphSettingsController = () => {
  const sigma = useSigma();
  const graph = sigma.getGraph();

  const {settings} = useTheCellMapContext();

  /**
   * Initialize here settings that require to know the graph and/or the sigma
   * instance:
   */
  useEffect(() => {
    sigma.setSetting("hoverRenderer", (context, data, settings) =>
      drawHover(context, {...sigma.getNodeDisplayData(data.key), ...data}, settings),
    );
    sigma.setSetting("labelRenderer", (context, data, settings) =>
      drawLabel(context, {...sigma.getNodeDisplayData(data.key), ...data}, settings),
    );
  }, [sigma, graph]);

  useEffect(() => {
    sigma.setSetting("labelRenderedSizeThreshold", settings.hideNodeLabels ? Infinity : 6);
  }, [settings, sigma]);

  return null;
};

export default React.memo(GraphSettingsController);
